<template>
  <div class="home">
<Navigation/>
    <div class="section bg-primary-3">
    <div class="container text-center">
      <h1>Coming Soon</h1>
      <div class="text-large">Showcase your listings before they are on the market.</div>
    </div>
  </div>
<Templates Category="coming-soon" />


  </div>

</template>

<script>
import Navigation from "@/components/Navigation.vue"
import Templates from "@/components/TemplateCollection.vue"

export default {
  name: "home",
  components: {
    Navigation,
    Templates
  }
};
</script>
